import hexToRgb from 'services/hexToRGB';

export function getFeedbackButtonHoverStyles(buttonProps: {
  backgroundColorOnHover: string;
  backgroundOpacityOnHover: number;
  textColorOnHover: string;
}) {
  const { r: hR, g: hG, b: hB } = hexToRgb(buttonProps?.backgroundColorOnHover);

  let backgroundHoverColorRGBA = `rgba(${hR}, ${hG}, ${hB}, ${buttonProps?.backgroundOpacityOnHover *
    0.01})`;

  //
  return {
    background: backgroundHoverColorRGBA,
    color: buttonProps?.textColorOnHover,
  };
}
